export default __webpack_public_path__ + "static/media/fk.dfd47d0e.svg";